// ##### 24-02-16 Komarov: файл с перечнем страниц, которые рендерятся на сервере

// TODO: Если страница отключена в Смарт, то закомментировать её и здесь.
// TODO: Сделать автоматическое определение страниц, которые нужно сюда добавить, и которые нужно закомментировать.
// ##### 24-02-21 Komarov
module.exports = {
  // Main page
  Main: '',
  // About Us page
  // ##### 25-04-21 Komarov: раскомментировал страницу: чтобы она была в SSR, иначе при обновлении вкладки приложение перенаправляет на главную страницу
  'About Us': '/sitepages/?name=About-Us&spid=2',
  // Mice page
  Mice: '/sitepages/?name=MICE&spid=18',
  // Gallery page
  Gallery: '/sitepages/?name=Gallery&spid=21',
  // Contact page
  // ##### 25-01-09 Komarov: раскомментировал страницу: чтобы она была в SSR, иначе при обновлении вкладки приложение перенаправляет на главную страницу
  Contact: '/sitepages/?name=Contact&spid=41',
  // ##### 24-09-04 Komarov
  // Contacts page
  Contacts: '/sitepages/?name=contacts&spid=5',
  // Clients page
  Clients: '/sitepages/?name=Clients&spid=42',
  // ##### 24-09-04 Komarov
  // Suppliers page
  Suppliers: '/sitepages/?name=Suppliers&spid=167',
  // ##### 24-09-04 Komarov
  // Group page
  Group: '/sitepages/?name=Group%20Request&spid=187',
  // War in Ukraine page
  'War in Ukraine': '/sitepages/?name=warukrainespec&spid=210',
  // About Us page (link from Footer)
  'About Us Footer': '/sitepages/?name=about-us&spid=1',
  // ##### 23-07-14 Komarov
  // Міста: Дніпро, Україна
  // ##### 24-07-22 Komarov
  // "Dnipro city": "/city_overview/?name=dnipro&spid=23&sptid=56",
  'Dnipro city': '/city_overview/?name=dnipro&spid=185&sptid=66',
  // Міста: Харків
  // ##### 24-07-22 Komarov
  // "Kharkiv city": "/city_overview/?name=kharkiv&spid=28&sptid=56",
  'Kharkiv city': '/city_overview/?name=kharkiv&spid=186&sptid=66',
  // Міста: Київ, Україна
  // ##### 24-07-22 Komarov
  // "Kyiv city": "/city_overview/?name=kyiv&spid=17&sptid=56",
  'Kyiv city': '/city_overview/?name=kyiv&spid=184&sptid=66',
  // Міста: Вінниця, Україна
  // ##### 24-07-22 Komarov
  // "Vinnitsa city": "/city_overview/?name=vinnitsa&spid=50&sptid=56",
  'Vinnitsa city': '/city_overview/?name=vinnitsa&spid=189&sptid=66',
  // Міста: Запоріжжя
  // ##### 24-07-22 Komarov
  // "Zaporozhie city": "/city_overview/?name=zaporozhie&spid=51&sptid=56",
  'Zaporozhie city': '/city_overview/?name=zaporozhie&spid=190&sptid=66',
  // Міста: Одеса, Україна
  // ##### 24-07-22 Komarov
  // "Odessa city": "/city_overview/?name=odessa&spid=42&sptid=56",
  'Odessa city': '/city_overview/?name=odessa&spid=188&sptid=66',
  // Міста: Львів, Україна
  // ##### 24-07-22 Komarov
  // "Lviv city": "/city_overview/?name=lviv&spid=38&sptid=56",
  'Lviv city': '/city_overview/?name=lviv&spid=187&sptid=66',
  // ##### 25-03-26 Komarov: раскомментировал для того, чтобы при обновлении страницы сайт не переходил на Главную
  // Інші Міста
  'Other Cities': '/city_overview/?name=others&spid=191&sptid=36',
  // ##### 25-03-26 Komarov: раскомментировал для того, чтобы при обновлении страницы сайт не переходил на Главную
  // Інші Готелі
  'Other Hotels': '/city_overview/?name=others&spid=365&sptid=36',
  // Визначні місця: Курортне, Одеська область, Україна
  'Kurortnoe sight': '/city_overview/?name=kurortnoe&spid=106&sptid=4',
  // Визначні місця: Грибівка, Одеська область, Україна
  'Grybivka sight': '/city_overview/?name=grybivka&spid=3&sptid=4',
  // Визначні місця: Генічеськ, Україна
  'Genichesk sight': '/city_overview/?name=genichesk&spid=4&sptid=4',
  // Визначні місця: Бердянськ, Україна
  'Berdyansk sight': '/city_overview/?name=berdyansk&spid=19&sptid=4',
  // Визначні місця: Маріуполь, Україна
  'Mariupol sight': '/city_overview/?name=mariupol&spid=39&sptid=4',
  // Визначні місця: Буковель Лижний Курорт, Україна
  'Bukovel sight': '/city_overview/?name=bukovel&spid=11&sptid=4',
  // Визначні місця: Яремче Курорт, Україна
  'Yaremche sight': '/city_overview/?name=yaremche&spid=58&sptid=4',
  // ##### 25-04-21 Komarov
  // nadiya-hotel
  'nadiya-hotel': '/hotel_overview/?id=173&city_id=40&hotel_name=nadiya-hotel',
  // ##### 25-04-21 Komarov
  // bank-hotel
  'bank-hotel': '/hotel_overview/?id=6331&city_id=51&hotel_name=bank-hotel',
  // ##### 25-04-21 Komarov
  // grand-hotel-lviv
  'grand-hotel-lviv':
    '/hotel_overview/?id=188&city_id=51&hotel_name=grand-hotel-lviv',
  // grand-hotel-dnipro
  'grand-hotel-dnipro':
    '/hotel_overview/?id=227&city_id=36&hotel_name=grand-hotel-dnipro',
  // ##### 25-04-21 Komarov
  // dnipro-kyiv
  'dnipro-kyiv': '/hotel_overview/?id=199&city_id=19&hotel_name=dnipro-kyiv',
  // ##### 25-04-21 Komarov
  // cityhotel
  cityhotel: '/hotel_overview/?id=802&city_id=19&hotel_name=cityhotel',
};
